import { render, staticRenderFns } from "./viewWorks.vue?vue&type=template&id=ef5b60e4&"
import script from "./viewWorks.vue?vue&type=script&lang=js&"
export * from "./viewWorks.vue?vue&type=script&lang=js&"
import style0 from "./viewWorks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports